// `sessionStorage` throws in some private windows, so callers get a fallback instead.
const getDataSessionStorage = (keyName) => {
  try {
    return sessionStorage.getItem(keyName);
  } catch (error) {
    return null;
  }
};

const setDataSessionStorage = (keyName, value) => {
  try {
    sessionStorage.setItem(keyName, value);
  } catch (error) {
    // Nothing to do: the value simply does not survive a reload.
  }
};

export { getDataSessionStorage, setDataSessionStorage };
